import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Home, Key, DollarSign, GitCompare, Search, Shield, CheckCircle, FileText, ClipboardList, Users, MessageSquare, Settings, X, Menu, LogOut, FileSearch } from 'lucide-react';

const navItems = [
  { path: '/', label: 'Dashboard', icon: Home },
  { path: '/budget', label: 'Buyer Budget', icon: DollarSign },
  { path: '/scenarios', label: 'My Scenarios', icon: GitCompare },
  { path: '/inspection', label: 'Inspection', icon: Search },
  { path: '/insurance', label: 'Insurance', icon: Shield },
  { path: '/move-in', label: 'Move-In', icon: CheckCircle },
  { path: '/documents', label: 'Documents', icon: FileText },
  { path: '/contract-review', label: 'Contract Review', icon: FileSearch },
  { path: '/reports', label: 'Reports', icon: ClipboardList },
  { path: '/collaboration', label: 'Collaboration', icon: Users },
  { path: '/assistant', label: 'AI Assistant', icon: MessageSquare },
  { path: '/settings', label: 'Settings', icon: Settings },
];

export default function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-50)' }}>
      <header style={{
        background: 'var(--dark)',
        color: 'white',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'white', textDecoration: 'none' }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'var(--primary)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}>
            <Key size={18} color="white" />
          </div>
          <span style={{ fontWeight: 700, fontSize: 18 }}>Closing Day Ontario</span>
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {user && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {user.profile_image_url && (
                <img
                  src={user.profile_image_url}
                  alt=""
                  style={{ width: 32, height: 32, borderRadius: '50%', border: '2px solid var(--primary)' }}
                />
              )}
              <span style={{ fontSize: 14, fontWeight: 500, display: 'none' }} className="user-name-desktop">
                {user.first_name || user.email}
              </span>
            </div>
          )}
          <button
            onClick={() => setMenuOpen(true)}
            style={{ background: 'none', color: 'white', padding: 8 }}
          >
            <Menu size={24} />
          </button>
        </div>
      </header>

      {menuOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 200,
          background: 'rgba(0,0,0,0.5)',
        }} onClick={() => setMenuOpen(false)}>
          <nav
            style={{
              position: 'absolute', top: 0, right: 0, bottom: 0,
              width: '100%', maxWidth: 400, background: 'white',
              overflowY: 'auto', padding: '0',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{
              background: 'var(--dark)', color: 'white',
              padding: '16px 24px', display: 'flex',
              alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: 'var(--primary)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                }}>
                  <Key size={18} color="white" />
                </div>
                <span style={{ fontWeight: 700, fontSize: 18 }}>Closing Day Ontario</span>
              </div>
              <button onClick={() => setMenuOpen(false)} style={{ background: 'none', color: 'white', padding: 8 }}>
                <X size={24} />
              </button>
            </div>

            {user && (
              <div style={{
                padding: '16px 24px', borderBottom: '1px solid var(--gray-200)',
                display: 'flex', alignItems: 'center', gap: 12,
              }}>
                {user.profile_image_url ? (
                  <img
                    src={user.profile_image_url}
                    alt=""
                    style={{ width: 40, height: 40, borderRadius: '50%', border: '2px solid var(--primary)' }}
                  />
                ) : (
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%', background: 'var(--primary-light)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'var(--primary)', fontWeight: 700, fontSize: 16,
                  }}>
                    {(user.first_name || user.email || '?')[0].toUpperCase()}
                  </div>
                )}
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    {user.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : 'User'}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{user.email}</div>
                </div>
              </div>
            )}

            <div style={{ padding: '8px 0' }}>
              {navItems.map(item => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMenuOpen(false)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 14,
                      padding: '14px 24px',
                      color: isActive ? 'var(--dark)' : 'var(--gray-700)',
                      background: isActive ? 'var(--primary-light)' : 'transparent',
                      fontWeight: isActive ? 600 : 400,
                      fontSize: 15,
                      textDecoration: 'none',
                      transition: 'all 0.15s',
                    }}
                  >
                    <Icon size={20} style={{ color: isActive ? 'var(--primary)' : 'var(--gray-500)' }} />
                    {item.label}
                  </Link>
                );
              })}
            </div>

            <div style={{ padding: '8px 24px 24px', borderTop: '1px solid var(--gray-200)' }}>
              <button
                onClick={logout}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                  padding: '12px 0', background: 'none', color: 'var(--red)',
                  fontSize: 15, fontWeight: 500, cursor: 'pointer',
                }}
              >
                <LogOut size={20} /> Sign Out
              </button>
            </div>
          </nav>
        </div>
      )}

      <main style={{ maxWidth: 960, margin: '0 auto', padding: '24px 16px 48px' }}>
        {children}
      </main>
    </div>
  );
}
